import { gql } from '@apollo/client';

export const BILLING_ECM_USERS = gql`
  query BillingEcmUsers($search: String, $limit: Int, $offset: Int) {
    billingEcmUsers(search: $search, limit: $limit, offset: $offset) {
      id username realname email organization site disabled totpEnrolled
    }
  }
`;
export const CREATE_BILLING_ECM_USER = gql`
  mutation CreateBillingEcmUser($input: CreateBillingEcmUserInput!) {
    createBillingEcmUser(input: $input) { success message username }
  }
`;
export const SET_BILLING_ECM_PASSWORD = gql`
  mutation SetBillingEcmUserPassword($username: String!, $password: String!) {
    setBillingEcmUserPassword(username: $username, password: $password) { success message }
  }
`;
export const SEND_BILLING_ECM_PASSWORD_RESET = gql`
  mutation SendBillingEcmPasswordReset($username: String!) {
    sendBillingEcmPasswordReset(username: $username) { success message }
  }
`;
export const SEND_BILLING_ECM_TOTP_RESET = gql`
  mutation SendBillingEcmTotpReset($username: String!) {
    sendBillingEcmTotpReset(username: $username) { success message emailSent expiresAt }
  }
`;
